import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import { getRecordInsertingPosition } from "./CopyAndPaste";
import { RECORD_TYPE, DATA_TYPE, FIELD_TYPE } from "../../../constants/datatypes";
import { t } from "i18next";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { genKey, isParentRecordLoop } from "../../../utils/utilFunctions";
import ErrorModal from "../../ItemProperties/Forms/FieldDataValidation/ErrorModal";

const NewRecordOutbound = ({ toggle, openModal }) => {
    const { t } = useTranslation();
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree } = useSelector(state => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const { translatedData } = rightTree.tree[currentTab]
    const [showModal, setShowModal] = useState(false);
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const content = t('BOX_LIKE_TO_PLACE_REC_INSIDE_CURR_REC_OR_DIRECTLY_AFTER').split(`\\n`).join("<br/>")
    const contentRef = useRef();
    const dispatch = useDispatch();

    const handleNewRecord = (isInside) => {
        let nestedLevels = selectedNode.key.split('-');
        nestedLevels = nestedLevels.splice(1);
        const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);

        // Function For Getting New Record Title and Key
        const getNewRecordData = (data, key, isInside) => {
            const title = getNewRecordName(rightTree.tree, true);

            //If it is empty so it will make first node with 'ib-0' key
            if (!data.length) {
                return { key: `${key}-0`, title }
            }

            let placingPosition;
            let newRecordKey;

            const details = getRecordInsertingPosition(data, selectedNode, isInside,'outbound', currentTab);
            placingPosition = details.index;
            newRecordKey = details.key;
            return { key: newRecordKey, title, placingPosition: placingPosition };
        }


        // Inserting New Node Object in Tree Data (Recursive Function);
        function insertNodeInNestedTree(translatedData, nestedLevels, isInside) {
            const level = isInside ? 0 : 1;
            if (nestedLevels.length === level) {
                const { children, key } = translatedData;
                const newRecordDetails = children ? getNewRecordData(children, key, isInside) : getNewRecordData(translatedData, {header: "obh-0", body: "ob-0", trailer: "obt-0"}[currentTab], isInside);
              
                const newNode = {
                    key: newRecordDetails.key,
                    title: `${t("LBL_RECORD")} ${newRecordDetails.title}`,
                    nodeId: genKey(newRecordDetails.title),                    
                    alternateNodeId: genKey(newRecordDetails.title),                    
                    ICON_DISPLAY : ['DATABASE'].includes(templateHeader.FILETYPE)
                    ? 'RECORD_LOOP'
                    : DATA_TYPE[templateHeader.FILETYPE]?.record?.icon,
                  
                    type: DATA_TYPE[templateHeader.FILETYPE]?.record?.icon,
                    // TYPE: t('SELECT'),
                    DESCRIPTION: newRecordDetails.title,
                    EDIT_RULE: [{TYPE: 'RECORD_RULE'}],
                    treeType: rightTree.currentTab,
                    // AUTO_DELIMIT: 'TRUE',
                    EMPTY_ACTION: 'EMPTY',
                    children: [],
                    LOOP: "SINGLE",
                    

                    ...DATA_TYPE[templateHeader.FILETYPE]?.record?.data
                };
                if(templateHeader.FILETYPE === 'JSON'){
                    newNode.EMPTY_ACTION = 'EMPTY'
                    newNode.SUPPRESS_ARRAY = 'FALSE'
                    newNode.SUPPRESS_ARRAY_NAME = 'FALSE'
                    newNode.SUPPRESS_ARRAY_NAME_ONLY = 'FALSE'
                    newNode.SUPPRESS_BRACES = 'FALSE'
                } else if(templateHeader?.FILETYPE === 'XML'){
                   newNode.XML_RECORD = 'TRUE'
                } else if(templateHeader?.FILETYPE === 'FIXED_LENGTH'){
                    newNode.EMPTY_ACTION = 'EMPTY'
                }
                dispatch(treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type: currentTab,
                    data: {}
                }));
                const translatedDataArray= children ? translatedData.children : translatedData;
                translatedDataArray.splice(newRecordDetails.placingPosition,0,newNode);
                setTimeout(() => {
                    dispatch(treeActions.setRightTreeSelectedNode({
                        screen: parentScreen,
                        type:currentTab, 
                        data:{...newNode}
                      }));
                })
                return;
        
               
        }
            const isArray = Array.isArray(translatedData);

            if (isArray) {
                const nestedData = translatedData[[nestedLevels[0]]];
                const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(nestedData, newNestedLevels, isInside);
            } else {
                // const newNestedLevels = nestedLevels.splice(1);
                insertNodeInNestedTree(translatedData?.children, nestedLevels, isInside);
            }
        }
        insertNodeInNestedTree(translatedData, nestedLevels, isInside);
        const updatedData = getUpdatedData(translatedData, templateHeader?.FILETYPE, null, false, currentTab);
        dispatch(treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: currentTab,
            data: updatedData
        }));
        toggle(prev => null);
        setShowModal(false);
    }


    setTimeout(() => {
        if (contentRef.current?.innerHTML === "") contentRef.current.innerHTML = content
    }, 0)


    const newRecordHandler = () => {
        if (parentScreen === "outbound" && selectedNode.key.split("-").length === 2) {
            handleNewRecord(true)
            return;
        }
        else if (templateHeader.FILETYPE === "JSON" && ( selectedNode?.key === "ob-0" || selectedNode?.key === "obh-0" || selectedNode?.key === "obt-0")) {
            handleNewRecord(true);
            return;
        }
        else if (["CONDITION_IF", "CONDITION_ELSE"].includes(selectedNode.ICON_DISPLAY) && openModal) {
            setShowModal(true);
        }
        else if (!RECORD_TYPE[selectedNode.ICON_DISPLAY] && openModal) {
            handleNewRecord(false);
            return;
        }
        else if ((selectedNode.key === "ob-0" || selectedNode.key === "obh-0" || selectedNode.key === "obt-0") && currentTab !== "body" && openModal) {
            handleNewRecord(true);
            return;
        }
        else if(templateHeader?.FILETYPE === 'XML' && selectedNode.ICON_DISPLAY === 'RECORD_LOOP' && currentTab === 'body' && isParentRecordLoop(translatedData,selectedNode)){
            setOpenErrorModal(true);
        }
        else {
            setShowModal(true);
        }
    }
    useEffect(() => {
        if (openModal) {
            newRecordHandler();
        }
    }, [openModal])

    return (
      <>
        <Dialog open={showModal} maxWidth="xs" fullWidth>
          <DialogTitle className="dialog-header">
            <div className="title">{t("BOX_CONFIRM")}</div>
          </DialogTitle>
          <DialogContent className="dialog-content" dividers>
            <div ref={contentRef}></div>
          </DialogContent>
          <DialogActions>
            <Button
              size='small'  
              variant="outlined"
              color="primary"
              onClick={() => handleNewRecord(true)}>
              {t("BTN_YES")}
            </Button>
            <Button
              size='small'
              variant="outlined"
              color="primary"
              onClick={() => handleNewRecord(false)}>
              {t("BTN_NO")}
            </Button>
            <Button
              size='small'
              variant="outlined"
              color="primary"
              onClick={() => {
                toggle(null);
                setShowModal(false);
              }}>
              {t("BTN_CANCEL")}
            </Button>
          </DialogActions>
        </Dialog>
        <ErrorModal
          errorModal={openErrorModal}
          handleErrorModal={() => setOpenErrorModal(false)}
          errorMessage={t("BOX_CANT_PLACE_ELEM_IN_ROOT_XML_RECORD")}
          errorType={t("BOX_ERR")}
        />
      </>
    );
};

export default NewRecordOutbound;

export const getUpdatedData = (translatedData, dataType, avoidNodeIdChange, isWorkflow = false, tab) => {
    const data = cloneDeep(translatedData);
    const key = isWorkflow ? "wf" : (tab === "body" ? "ob" : tab === "header" ? "obh" : "obt");
    // const key = 'ob';
    const fixedLengthDataType = dataType === "FIXED_LENGTH";

    const getNewKeys = (data, key) => {
        let fieldNumber = dataType === "EDI" ? 0 : 1;
        let beginNumber = 1;
        let ifId = "";
        data.forEach((ele, idx) => {
            const newKey = `${key}-${idx}`;
            if (FIELD_TYPE[ele.ICON_DISPLAY] || ['FIELD_GROUP', 'REPEATING_FIELD_GROUP'].includes(ele?.ICON_DISPLAY)) {
                data[idx] = {
                    ...data[idx],
                    key: newKey,
                    fieldNumber: fieldNumber++
                }
                if (fixedLengthDataType) { //Fixed Length Data Type Begin and End.
                    // data[idx].BEGIN = Number(beginNumber);
                    // data[idx].END = !data[idx]?.LENGTH ? '' : Number(beginNumber) + (Number(data[idx]?.LENGTH) || 0) - 1;
                    // beginNumber += !data[idx]?.LENGTH ? 0 : (Number(data[idx]?.LENGTH) || 0);
                }
            }
            else {
                if (ele?.ICON_DISPLAY === "CONDITION_IF") ifId = genKey();
                data[idx] = {
                    ...data[idx],
                    key: newKey,
                    nodeId: avoidNodeIdChange ? data[idx]?.nodeId : ["CONDITION_IF", "CONDITION_ELSE"].includes(ele?.ICON_DISPLAY) ? ifId : data[idx]?.nodeId
                }
                if(ele?.ICON_DISPLAY !== "CONDITION_IF" || data?.[idx + 1]?.ICON_DISPLAY !== "CONDITION_ELSE") ifId = "";
            }


            if (ele.children?.length > 0) {
                data[idx].isLeaf = false;
                getNewKeys(ele.children, newKey);
            } else {
                data[idx].isLeaf = true;
            }

        })
    }
    getNewKeys(data, key);

    return data;
}

export const getNewRecordName = (tree, isOutbound) => {
	////--------------------Function to Get New Record New On Every Record Creation------------------------////

	const data = cloneDeep(tree);
	const body = data.body.translatedData;
	const header = data.header.translatedData;
	const trailer = data.trailer.translatedData;
	let titleNumber = 0;

	const getTitleName = (data) => {
		data.forEach((ele, idx) => {
			if (
				RECORD_TYPE[ele?.ICON_DISPLAY] &&
				ele?.title?.includes(t("UNNAMED"))
			) {
				let title = isOutbound
					? ele?.title?.replace(`${t("LBL_RECORD")} `, "")
					: ele.title;
				const indexOfUnderScore = title.indexOf("_");
				title =
					indexOfUnderScore >= 0 ? title.slice(0, indexOfUnderScore) : title;
				const latestUnnamedRecord = +title.slice(t("UNNAMED").length);

				if (!isNaN(latestUnnamedRecord)) {
					titleNumber =
						latestUnnamedRecord > titleNumber
							? latestUnnamedRecord
							: titleNumber;
				}
			}
			if (ele?.children?.length > 0) {
				getTitleName(ele.children);
			}
		});
	};

	getTitleName(body);
	getTitleName(header);
	getTitleName(trailer);

	return `${t("UNNAMED")}${Number(titleNumber) + 1}`;
};